module.exports = __webpack_public_path__ + "img/sidebar.32103624.jpg";